import { Injectable } from '@angular/core';
import { Response, Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { APIResponse, User, FirstTimeUser, SwitchRole } from '../models';

import { UserService } from './user.service';
import { TokenService } from './token.service';
import 'rxjs/Rx';

@Injectable()
export class AuthenticationService {
  // create Observable to be subscribed by Subscriber
  private loginStateSubject = new ReplaySubject<boolean>(1);
  public loginState = this.loginStateSubject.asObservable();

  private isFirstTimeSubject = new BehaviorSubject<boolean>(true);
  public isFirstTime = this.isFirstTimeSubject
    .asObservable()
    .distinctUntilChanged();

  private userInfoSubject = new BehaviorSubject<User>(new User());
  public userInfo = this.userInfoSubject.asObservable().distinctUntilChanged();

  constructor(
    private http: Http,
    private userService: UserService,
    private tokenService: TokenService
  ) { }

  // verify JWT in localstorage with Laravel & load user's info to be used in App
  // only called in the angular app startup and role switching
  load(): Promise<void> {
    const token = this.tokenService.getToken();

    if (token === null) {
      // localstorage is empty
      this.logout();
    } else {
      // localstorage has token
      return this.userService.getCurrentUserProfile().then(userres => {
        if (userres.success === false) {
          // token invalid
          this.logout();
          return;
        }
        if (userres.data.agreeterms_at === null) {
          this.isFirstTimeSubject.next(true);
        } else {
          this.isFirstTimeSubject.next(false);
        }
        this.userInfoSubject.next(userres.data);
        this.loginStateSubject.next(true);
      });
    }
  }

  login(data: any): Promise<APIResponse<FirstTimeUser, any>> {
    return this.userService.login(data).then(res => {
      if (res.success === true) {
        this.tokenService.setToken(res.data.token);
        this.isFirstTimeSubject.next(res.data.isFirstTime);
        return this.userService.getCurrentUserProfile().then(userres => {
          if (userres.data.agreeterms_at === null) {
            this.isFirstTimeSubject.next(true);
          } else {
            this.isFirstTimeSubject.next(false);
          }
          this.userInfoSubject.next(userres.data);
          this.loginStateSubject.next(true);
          return res;
        });
      } else {
        return res;
      }
    });
  }

  logout(): void {
    // clear token from local storage to log user out
    this.tokenService.removeToken();
    this.loginStateSubject.next(false);
    // this.userInfoSubject.next(new User());
  }

  // used in auth guard, to make sure if the user is already logged in
  isAuthenticated(): Promise<boolean> {
    return this.loginState.take(1).toPromise();
  }

  checkFirstTime(): Promise<boolean> {
    return this.isFirstTime.toPromise();
  }

  setIsFirstTime(value: boolean): void {
    // if user has clicked agree, success value = true and isFirstTime value = false
    this.isFirstTimeSubject.next(value);
  }

  // saves the user info to be used across application,
  // without having to fetch user info from server several times
  getUserInfo(): User {
    return this.userInfoSubject.getValue();
  }

  switchRole(i: number): Promise<APIResponse<SwitchRole, any>> {
    return this.userService.switchRole(i).then(res => {
      this.tokenService.removeToken();
      this.tokenService.setToken(res.data.token);
      return this.load().then(() => {
        console.log('switch role', res.data);
        return res;
      });
    });
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/authentication.service.ts